import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth';

const auth = getAuth();
const provider = new GoogleAuthProvider();

const AuthIdb = {
  registerUser: async (email, password) =>
    createUserWithEmailAndPassword(auth, email, password),
  loginUser: async (email, password) =>
    signInWithEmailAndPassword(auth, email, password),
  logoutUser: async () => signOut(auth),
  loginGoogle: async () => signInWithPopup(auth, provider),
};

export default AuthIdb;
